// extracted by mini-css-extract-plugin
export default {"sideMenu":"sidemenu_sideMenu__5nQ0W","wrapper":"sidemenu_wrapper__MSYYY","selected":"sidemenu_selected__ouS11"};